import { Icon, Label } from "semantic-ui-react";
import { BOOKING_STATUS_COLOR } from "./adminHelpers";

const STATUS_ICON = {
  Pending: "clock outline",
  Approved: "check circle outline",
  Rejected: "times circle outline",
  Cancelled: "ban",
  "Partially Confirmed": "adjust",
  Transferred: "exchange",
  "Checked In": "sign in",
  "Checked Out": "sign out",
  "No Show": "user times",
};

export default function StatusBadge({ status }) {
  return (
    <Label color={BOOKING_STATUS_COLOR[status] || "grey"}>
      <Icon name={STATUS_ICON[status] || "clock outline"} />
      {status}
    </Label>
  );
}
